import { Module } from 'vuex';
import { ShiftCMSState } from '@/store';
import bptService from '@/services/bpt.service';
import { BPTQuestion } from '@/models/bpt.model';

export interface BPTStoreState {
  questions: BPTQuestion[];
}

export enum BPTStoreMutations {
  SetQuestions = 'bpt/SetQuestions',
}

export enum BPTStoreActions {
  GetBPTQuestions = 'bpt/GetBPTQuestions',
  GetBPTQuestion = 'bpt/GetBPTQuestion',
  AddBPTQuestion = 'bpt/AddBPTQuestion',
  UpdateBPTQuestion = 'bpt/UpdateBPTQuestion',
  UpdateQuestionOrder = 'bpt/UpdateQuestionOrder',
}

const sn = (str: BPTStoreActions | BPTStoreMutations): string =>
  str.replace(/bpt\//g, '');

export const bptStore: Module<BPTStoreState, ShiftCMSState> = {
  namespaced: true,
  state: {
    questions: [],
  },
  mutations: {
    [sn(BPTStoreMutations.SetQuestions)](state, questions: BPTQuestion[]) {
      state.questions = questions;
    },
  },
  actions: {
    async [sn(BPTStoreActions.GetBPTQuestions)]({ commit }) {
      const res = await bptService.getList();
      if (res.status) {
        commit(sn(BPTStoreMutations.SetQuestions), res.data);
      }
    },
    async [sn(BPTStoreActions.GetBPTQuestion)](_, id: number) {
      const res = await bptService.get(id);
      if (res.status) {
        return res.data;
      }
    },
    async [sn(BPTStoreActions.AddBPTQuestion)](_, story: BPTQuestion) {
      const res = await bptService.create({
        ...story,
        id: undefined,
      });

      return res.status;
    },
    async [sn(BPTStoreActions.UpdateBPTQuestion)](_, story: BPTQuestion) {
      const res = await bptService.edit(story);

      return res.status;
    },
    async [sn(BPTStoreActions.UpdateQuestionOrder)](
      { commit },
      order: number[],
    ) {
      const res = await bptService.updateOrder(order);

      if (res.status) {
        commit(sn(BPTStoreMutations.SetQuestions), res.data);
      }
    },
  },
};
